import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Controller } from "../interface/controller.interface";
import { HTTPMethod } from "../model/http-method.enum";
import { HTTPRequestBuilder } from "../model/http.request.model";
import { HTTPService } from "./http.service";
import { Discount } from "../persistence/dto/discount.model";

    /**
     * @description
     *  Servicio reflejo del controlador de descuentos del backend.
     *
     * @see gigot-backend/Controllers/Configuration/DiscountController.cs
     */

@Injectable({ providedIn: "root" })
export class DiscountService implements Controller {

    constructor(private httpService: HTTPService) {}

	public discountByOrderID(orderId: number): Observable<Discount> {
        return this.httpService.send<typeof undefined, Discount>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath(`order/${orderId}`)
                .build())
            .pipe(
				map(discount => Discount.from(discount)));
    }

    public basePath(): string {
        return "api/discount";
    }
}
